import { createContext } from 'react';

export const MobileNavContext = createContext(null);
